import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { ViewUtils } from "@lib/titan2/dist/util/view/ViewUtils";
import { gsap } from "gsap";
import { Service } from "../../../../api/Service";
import { FreeSpinOverlayEvent, SlingoEvent } from "../../../controller/event/SlingoEvent";
import { SlingoStyle } from "../style/SlingoStyle";
import { AbstractGameView } from "./AbstractGameView";
import { ArcadeWheelEvent } from "./ArcadeWheel";
/**
 * SpinsState.ts
 */
export var SpinsState;
(function (SpinsState) {
    SpinsState[SpinsState["START"] = 0] = "START";
    SpinsState[SpinsState["STANDARD"] = 1] = "STANDARD";
    SpinsState[SpinsState["FREE"] = 2] = "FREE";
    SpinsState[SpinsState["PURCHASE"] = 3] = "PURCHASE";
})(SpinsState || (SpinsState = {}));
/**
 * SpinsRemaining.ts
 */
export class SpinsRemaining extends AbstractGameView {
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.landscapeProperties = properties;
        this.portraitProperties = portraitProperties;
    }
    create() {
        super.create();
        this.background = TitanSprite.createSprite(this, "background", this.landscapeProperties.backgroundProperties, this.portraitProperties?.backgroundProperties); //TitanSpine.createSpine(this, this.landscapeProperties.backgroundProperties, this.portraitProperties?.backgroundProperties);
        this.backgroundFree = TitanSprite.createSprite(this, "backgroundFree", this.landscapeProperties.backgroundFreeProperties, this.portraitProperties.backgroundFreeProperties);
        this.backgroundPurchase = TitanSprite.createSprite(this, "backgroundPurchase", this.landscapeProperties.backgroundPurchaseProperties, this.portraitProperties?.backgroundPurchaseProperties);
        this.standard = ViewUtils.createField(this, this.landscapeProperties.standardProperties, this.portraitProperties?.standardProperties);
        this.purchase = ViewUtils.createField(this, this.landscapeProperties.purchaseProperties, this.portraitProperties?.purchaseProperties);
    }
    postCreate() {
        super.postCreate();
        this.state = SpinsState.START;
        this.backgroundPurchase.visible = false;
        this.background.setTrackingId(SlingoStyle.REMAINING_SPINS);
        this._pendingFreeSpins = 0;
        //update background spine to make it visible
        //SpineUtil.gotoAndStop(this.background, 99, SpineAnimation.UPDATE_SPINS_REMAINING);
        Logger.addObjectRef(this, "SpinsRemaining");
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(CommonGameEvent.PURCHASE_ENTRY, this.handlePurchaseEntry);
        this.registerGame(CommonGameEvent.SPIN, this.handleStandardSpin);
        this.registerGame(CommonGameEvent.FREE_SPIN, this.handleFreeSpin);
        this.registerGame(CommonGameEvent.PURCHASE_SPIN, this.handlePurchaseSpin);
        this.registerGame(SlingoEvent.GAME_SUMMARY, this.handleGameSummary);
        this.registerGame(SlingoEvent.FREE_SPIN_AWARD, this.handleFreeSpinAward);
        this.registerGame(CommonGameEvent.STANDARD_SPIN_RECOVERY, this.handleStandardSpinRecovery);
        this.registerGame(CommonGameEvent.FREE_SPIN_RECOVERY, this.handleFreeSpinRecovery);
        this.registerGame(CommonGameEvent.PURCHASE_SPIN_RECOVERY, this.handlePurchaseSpinRecovery);
        this.registerGame(SlingoEvent.SPIN_RESULT, this.handleSpinResult);
        this.registerGame(SlingoEvent.REELS_COMPLETE, this.handleReelsComplete);
        this.registerGame(FreeSpinOverlayEvent.FREE_SPIN_END, this.handleFreeSpinEnd);
        this.registerGame(CommonGameEvent.REPLAY_PURCHASE_ENTRY, this.handleReplayPurchaseEntry);
        this.registerGame(ArcadeWheelEvent.SHOW, this.handleArcadeWheelShow);
        this.registerGame(ArcadeWheelEvent.HIDE, this.handleArcadeWheelHide);
        this.registerGame(ArcadeWheelEvent.WIN, this.handleArcadeWheelHide);
        this.registerGame(ArcadeWheelEvent.REPLAY_SPIN_COMPLETE, this.handleArcadeWheelReplaySpinComplete);
    }
    handleReplayPurchaseEntry() {
        console.log("[SpinsRemaining] - handleReplayPurchaseEntry()");
        this.updatePurchase(0);
        this.updateSpinsRemaining();
        this.handleStandardSpin();
    }
    handlePurchaseEntry() {
        const config = this.model.getGameConfig();
        this.updateStandard(config.getNumberOfSpins());
        this.updatePurchase(0);
        this.handleStandardSpin();
    }
    handleFreeSpinAward() {
        this.dispatchGame(FreeSpinOverlayEvent.FREE_SPIN_START);
        this._pendingFreeSpins++;
    }
    handleFreeSpinEnd() {
        this._pendingFreeSpins--;
        if (Service.isReplay()) {
            this.updateStandard(parseInt(this.standard.getText(), 10));
        }
        else if (this.state === SpinsState.STANDARD || this.state === SpinsState.FREE) {
            this.updateStandard(parseInt(this.standard.getText(), 10) + 1);
        }
        else if (this.state === SpinsState.PURCHASE) {
            this.updatePurchase(parseInt(this.purchase.getText(), 10) + 1);
        }
        const freeSpinsAwarded = this.model.getGameProgress()?.getFreeSpinsAwarded() || 0;
        this.model.dispatchKPI("SLINGO_STATE", "FREE_SPIN_AWARDED", `${freeSpinsAwarded}`);
    }
    handleStandardSpin() {
        this.state = SpinsState.STANDARD;
        this.standard.visible = true;
        this.purchase.visible = false;
        this.background.visible = true;
        this.backgroundPurchase.visible = false;
        this.backgroundFree.visible = false;
        this.show();
    }
    handleFreeSpin() {
        this.state = SpinsState.FREE;
        this.standard.visible = true;
        this.purchase.visible = false;
        this.background.visible = false;
        this.backgroundPurchase.visible = false;
        this.backgroundFree.visible = true;
        this.show();
    }
    handlePurchaseSpin() {
        this.state = SpinsState.PURCHASE;
        this.standard.visible = false;
        this.purchase.visible = true;
        this.background.visible = false;
        this.backgroundPurchase.visible = true;
        this.backgroundFree.visible = false;
        //SpineUtil.gotoAndStop(this.background, 99, SpineAnimation.UPDATE_PURCHASE_SPINS_REMAINING);
        this.show();
    }
    handleGameSummary() {
        //SpineUtil.gotoAndStop(this.background, 99, SpineAnimation.UPDATE_SPINS_REMAINING);
        this.state = SpinsState.START;
        this.handleArcadeWheelHide();
    }
    handleResponsibleGamingLimit() {
        this.handlePurchaseSpin();
        this.updateSpinsRemaining();
    }
    handleStandardSpinRecovery() {
        this.handleStandardSpin();
        this.updateSpinsRemaining();
    }
    handleFreeSpinRecovery() {
        this.handleFreeSpin();
        this.updateSpinsRemaining();
    }
    handlePurchaseSpinRecovery() {
        this.handlePurchaseSpin();
        this.updateSpinsRemaining();
    }
    handleSpinResult() {
        if (this.state === SpinsState.STANDARD || this.state === SpinsState.FREE) {
            if (parseInt(this.standard.getText(), 10) == 0) {
                console.warn("attempt to set -ve spin amount");
            }
            else {
                this.updateStandard(parseInt(this.standard.getText(), 10) - 1);
            }
        }
        else if (this.state === SpinsState.PURCHASE) {
            if (parseInt(this.purchase.getText(), 10) == 0) {
                console.warn("attempt to set -ve spin amount");
            }
            else {
                this.updatePurchase(parseInt(this.purchase.getText(), 10) - 1);
            }
        }
    }
    handleArcadeWheelReplaySpinComplete() {
        if (Service.isReplay()) {
            this.updateSpinsRemaining();
        }
    }
    handleReelsComplete() {
        this.updateSpinsRemaining();
    }
    handleResize(event) {
        if (this.renderer.isLandscape()) {
            this.anchorRight(this.background, this.uiProperties.backgroundProperties, this.renderer.getSafeTransform().x / 10 * 8);
            this.anchorRight(this.standard, this.uiProperties.backgroundProperties, this.renderer.getSafeTransform().x / 10 * 8);
            this.anchorRight(this.purchase, this.uiProperties.backgroundProperties, this.renderer.getSafeTransform().x / 10 * 8);
        }
    }
    handleRotate(event) {
        super.handleRotate(event);
        this.uiProperties = this.uiProperties;
        if (this.hasPortraitProperties) {
            this.layouts = [];
            this.applyProperties();
            this.resizeView(this.background, this.uiProperties.backgroundProperties);
            this.resizeView(this.standard, this.uiProperties.standardProperties);
            this.resizeView(this.purchase, this.uiProperties.purchaseProperties);
        }
    }
    handleArcadeWheelShow() {
        this.purchase.alpha = 0.5;
    }
    handleArcadeWheelHide() {
        this.purchase.alpha = 1.0;
    }
    updateSpinsRemaining() {
        const game = this.model.getGameProgress();
        const spinsRemaining = game.getSpinsRemaining();
        const freeSpinsRemaining = game.getFreeSpinsRemaining() - this._pendingFreeSpins;
        this.updateStandard(spinsRemaining + freeSpinsRemaining);
        this.updatePurchase(this.responsibleGaming.getPurchaseSpinsRemaining());
    }
    updateText(textObj, text) {
        this.uiProperties = this.uiProperties;
        textObj.setText(text);
    }
    playAnim(increment) {
        let textObj;
        switch (this.state) {
            case SpinsState.PURCHASE:
                textObj = this.purchase;
                //SpineUtil.play(this.background, SpineAnimation.UPDATE_PURCHASE_SPINS_REMAINING + (increment ? "flash" : ""));
                break;
            case SpinsState.STANDARD:
            case SpinsState.FREE:
                textObj = this.standard;
                //SpineUtil.play(this.background, SpineAnimation.UPDATE_SPINS_REMAINING + (increment ? "flash" : ""));
                break;
            default:
                break;
        }
        if (textObj && textObj.getPixiText()) {
            gsap.to(textObj.getPixiText().scale, {
                repeat: 1,
                duration: this.uiProperties.updateTweenProperties.duration,
                x: this.uiProperties.updateTweenProperties.scale,
                y: this.uiProperties.updateTweenProperties.scale,
                yoyo: true
            });
        }
    }
    updateStandard(value) {
        const oldValue = parseInt(this.standard.getText());
        if (value !== oldValue) {
            this.playAnim(value > oldValue);
        }
        this.updateText(this.standard, String(value));
    }
    updatePurchase(value) {
        let text = String(value);
        if (value > 100) {
            text = "∞";
        }
        this.updateText(this.purchase, text);
    }
}
//# sourceMappingURL=SpinsRemaining.js.map